export const SITES = {
    SITE_NAME: "site-name",
    SHOPPABLE_VIDEO: "shoppable-video",
    SELECT_SHOPPABLE_MOMENT: "select-shoppable-moment",
    ADD_TIME_TAG: "add-time-tag",
    TAG_MIN: "tag-min",
    TAG_MAX: "tag-max",
    PREVIEW_DESCRIPTION: "preview-description",
    TAG_LIST: "tag-list",
    CLEAR_TAGS: "clear-tags",
    GO_BACK: "go-back",
    CUSTOMER_GROUPS_DROPDOWN: "customer-groups-dropdown",

    INTEGRATION_PAGE_LINK: "matterport-integration",
    INTEGRATION_PAGE_DESCRIPTION: "page-description",
    INTEGRATION_KEY_INPUT: "key-input-field",
    INTEGRATION_INVALID_ALERT: "invalid-key-alert",
    INTEGRATION_MISSING_ALERT: "missing-key-alert",
    INTEGRATION_SUCCESS_ALERT: "success-key-alert",

    SPACES_3D_BLOCK: "spaces-3d-block",
    SPACES_3D_COMPONENT_PLACEHOLDER: "spaces-3d-component-placeholder",
    SPACES_3D_COMPONENT_IFRAME: "spaces-3d-component-iframe",
    SPACES_3D_COMPONENT_CLICK_OVERLAY: "spaces-3d-component-click-overlay",
    SPACES_3D_TRAITS_SPACE_INPUT: "spaces-3d-traits-space-input",
    SPACES_3D_TRAITS_SPACE_META: "spaces-3d-traits-space-meta",
    SPACES_3D_TRAITS_SPACE_CLEAR: "spaces-3d-traits-space-clear",
    SPACES_3D_TRAITS_SPACE_CLEAR_WARNING_MODAL_ACCEPT: "spaces-3d-traits-space-clear-warning-modal-accept",
    SPACES_3D_TRAITS_TOGGLES: "spaces-3d-traits-toggles",
    SPACES_3D_TRAITS_ADD_REMOVE_HOTSPOTS: "spaces-3d-traits-add-remove-hotspots",
    SPACES_3D_TRAITS_NO_SDK: "spaces-3d-traits-no-sdk",
    SPACES_3D_TRAITS_SDK_ERROR: "spaces-3d-traits-sdk-error",
    SPACES_3D_TRAITS_SPACE_ID_ERROR: "spaces-3d-traits-space-id-error",
    SPACES_3D_MODAL: "spaces-3d-modal",
    SPACES_3D_MODAL_IFRAME: "spaces-3d-modal-iframe",
    SPACES_3D_MODAL_ADD_BUTTON: "spaces-3d-modal-add-button",
    SPACES_3D_MODAL_REMOVE_ALL_BUTTON: "spaces-3d-modal-remove-all-button",
    SPACES_3D_MODAL_REMOVE_ALL_WARNING_ACCEPT: "spaces-3d-modal-remove-all-warning-accept",

    PRODUCT_3D_INTERACT_BTN: "product-3d-interact-btn",
    PRODUCT_3D_INDICATOR: "product-3d-indicator",
    PRODUCT_3D_CARTABLE: "product-3d-cartable",
    PRODUCT_3D_IFRAME: "product-3d-iframe",
    PRODUCT_3D_PLACEHOLDER: "product-3d-placeholder",
};
